import { render, staticRenderFns } from "./mainViews.vue?vue&type=template&id=60697cb2&"
import script from "./mainViews.vue?vue&type=script&lang=js&"
export * from "./mainViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports